import { Box, Typography, Container, Button, Grid, Card, CardMedia, CardContent, Divider, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

const ThankYou = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ backgroundColor: "#000000", minHeight: "100vh", py: 6 }}>
      <Container maxWidth="md" sx={{ textAlign: "center" }}>
        <img
          src="/rocket-stacked-white.png"
          alt="Rocket Offer Logo"
          style={{ height: "80px", marginBottom: "1rem" }}
        />
        <Typography variant="h4" gutterBottom>
          Welcome to Rocket Offer!
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          Thanks for signing up. You're now ready to explore powerful tools for buying, selling, and investing in real estate.
        </Typography>

        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <Card sx={{ height: "100%" }}>
              <CardMedia
                component="img"
                image="/userguide/sign-in-button.png" 
                alt="Sign-In Button Preview"
                  sx={{
                    height: 160,
                    width: '100%',
                    objectFit: 'contain', // 🔁 This avoids cropping
                  }}
              />
              <CardContent>
                <Typography variant="h6">Sign In Button</Typography>
                <Typography variant="body2">
                  Click here to sign into the app.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Card sx={{ height: "100%" }}>
              <CardMedia
                component="img"
                image="/userguide/sign-in.png" 
                alt="Submit Property"
                sx={{
                  height: 160,
                  width: '100%',
                  objectFit: 'contain', 
                }}
              />
              <CardContent>
                <Typography variant="h6">Enter Your Credentials</Typography>
                <Typography variant="body2">
                  Provide the email and password you gave when you registered.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Card sx={{ height: "100%" }}>
              <CardMedia
                component="img"
                image="/userguide/sign-in.png" 
                alt="Submit Property"
                sx={{
                  height: 160,
                  width: '100%',
                  objectFit: 'contain', 
                }}
              />
              <CardContent>
                <Typography variant="h6">Enter Your Credentials</Typography>
                <Typography variant="body2">
                  Provide the email and password you gave when you registered.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Card sx={{ height: "100%" }}>
              <CardMedia
                component="img"
                image="/userguide/sign-in.png" 
                alt="Submit Property"
                sx={{
                  height: 160,
                  width: '100%',
                  objectFit: 'contain', 
                }}
              />
              <CardContent>
                <Typography variant="h6">Enter Your Credentials</Typography>
                <Typography variant="body2">
                  Provide the email and password you gave when you registered.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Card sx={{ height: "100%" }}>
              <CardMedia
                component="img"
                image="/userguide/sign-in.png" 
                alt="Submit Property"
                sx={{
                  height: 160,
                  width: '100%',
                  objectFit: 'contain', 
                }}
              />
              <CardContent>
                <Typography variant="h6">Enter Your Credentials</Typography>
                <Typography variant="body2">
                  Provide the email and password you gave when you registered.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Card sx={{ height: "100%" }}>
              <CardMedia
                component="img"
                image="/userguide/sign-in.png" // Replace with your actual image path
                alt="Submit Property"
                sx={{
                  height: 160,
                  width: '100%',
                  objectFit: 'contain', // 🔁 This avoids cropping
                }}
              />
              <CardContent>
                <Typography variant="h6">Enter Your Credentials</Typography>
                <Typography variant="body2">
                  Provide the email and password you gave when you registered.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Divider sx={{ mb: 2 }} />



        <Box sx={{ p: 2 }}>
          <Stack spacing={2}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant="body2">Need help or have questions? You can always get ahold of us at: </Typography>
              <EmailIcon color="primary" />
              <Typography variant="body1">info@rocketoffer.com</Typography>
              <PhoneIcon color="primary" />
              <Typography variant="body1">(248) 270-2000</Typography>
            </Stack>
          </Stack>
        </Box>

        <Typography variant="body1">
          Ready to get started?
        </Typography>

        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 5 }}
          onClick={() => navigate("/dashboard")}
        >
          Go to My Dashboard
        </Button>
      </Container>
    </Box>
  );
};

export default ThankYou;
